import { render, staticRenderFns } from "./VersionDescriptionNX.vue?vue&type=template&id=b0fe4940&scoped=true"
import script from "./VersionDescriptionNX.vue?vue&type=script&lang=js"
export * from "./VersionDescriptionNX.vue?vue&type=script&lang=js"
import style0 from "./VersionDescriptionNX.vue?vue&type=style&index=0&id=b0fe4940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fe4940",
  null
  
)

export default component.exports